/**
 * Resolve locale for GraphQL x-locale header.
 * @param {string} [serverLocale] - Locale from server (e.g. request headers).
 * @returns {string} - Locale code, default 'fr'.
 */
function getLocale(serverLocale) {
  if (serverLocale) return serverLocale;
  if (typeof document !== 'undefined' && document.documentElement?.getAttribute('lang')) {
    return document.documentElement.getAttribute('lang');
  }
  return 'fr';
}

export default getLocale;
